import React from "react";
import MultiSelectDropdown from "./base/MultiSelectDropdown";
import { resolveErrorMessage } from "../../../util";
import { getCities } from "../../../actions/Location";

const SelectWithCitiesFromStates = ({ selectedStates, setSelectedCities }) => {
  const [availableCities, setAvailableCities] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const onChangeCities = (values) => {
    setSelectedCities(values);
  };

  React.useEffect(() => {
    const fetchCities = async () => {
      try {
        if (!selectedStates?.length) return;
        setAvailableCities([]);
        setLoading(true);
        setError(null);
        const statesArray = Array.isArray(selectedStates) ? selectedStates : [selectedStates];

        const cities = await getCities({
          states: statesArray,
        });

        if (!cities?.length) {
          throw new Error("app.error.notAvailable.cities");
        }
        const formattedCities = cities.map((city) => ({
          value: city,
          label: city ?? "N?A",
        }));

        setAvailableCities(formattedCities);
      } catch (e) {
        const errorMessage = resolveErrorMessage(e);
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };
    fetchCities();
  }, [selectedStates]);

  return (
    <MultiSelectDropdown
      key={selectedStates.join(",")}
      title="app.cities"
      values={availableCities}
      onChange={onChangeCities}
      error={error}
      loading={loading}
      loadingMessage="app.loading.fetching.cities"
      emptyMessage="app.state.noStatesSelected"
      enableIntlOption={false}
    />
  );
};

export default SelectWithCitiesFromStates;
